import {
  FontIcon,
  IconButton,
  Link,
  SearchBox,
  Stack,
  TooltipHost,
} from '@fluentui/react';
import { useStyles } from '../index.styles';

import { useLazyQuery } from '@apollo/client';
import { getSearchInputStyles } from 'common/components/SearchBar';
import { useEffect } from 'react';
import {
  TrainingFolders_trainingFolders_nodes__childFolders_edges_node__childFolders_nodes_trainingFiles_nodes,
  TrainingFolders_trainingFolders_nodes__childFolders_edges_node_trainingFiles_nodes,
} from '../__generated__/TrainingFolders';
import LOOK_UP_TRAINING_SEARCH from './LookupTrainingSearch.graphql';
import {
  LookupTrainingSearch,
  LookupTrainingSearch_lookupTrainingSearch_nodes,
  LookupTrainingSearchVariables,
} from './__generated__/LookupTrainingSearch';
interface HelpSearchBarProps {
  setIsGlobalSearch: React.Dispatch<React.SetStateAction<boolean>>;
  isGlobalSearch: boolean;
  setSearchValue: React.Dispatch<React.SetStateAction<string | null>>;
  searchValue: string | null;
  setTrainingFilesNodes: React.Dispatch<
    React.SetStateAction<
      | TrainingFolders_trainingFolders_nodes__childFolders_edges_node__childFolders_nodes_trainingFiles_nodes[]
      | TrainingFolders_trainingFolders_nodes__childFolders_edges_node_trainingFiles_nodes[]
      | LookupTrainingSearch_lookupTrainingSearch_nodes[]
    >
  >;
  onModeChange: () => void;
  isDataAvailable: boolean;
  isModuleHelpEmpty: boolean;
}

export const HelpSearchBar: React.FC<HelpSearchBarProps> = ({
  isGlobalSearch,
  setIsGlobalSearch,
  searchValue,
  setSearchValue,
  setTrainingFilesNodes,
  onModeChange,
  isDataAvailable,
  isModuleHelpEmpty,
}) => {
  const styles = useStyles();
  const searchInputPlaceholderText = 'Search by keyword';

  const [
    lookupTrainingSearch,
    { loading: lookupTrainingSearchLoading, data: lookupTrainingSearchData },
  ] = useLazyQuery<LookupTrainingSearch, LookupTrainingSearchVariables>(
    LOOK_UP_TRAINING_SEARCH,
    {
      variables: {
        orderBy: ['NAME_ASC'],
        lookupName: searchValue ?? '',
      },
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'cache-only',
    }
  );
  useEffect(() => {
    if (searchValue === null) return;
    setIsGlobalSearch(false);
    onModeChange();
    const handler = setTimeout(() => {
      lookupTrainingSearch({
        variables: {
          orderBy: ['NAME_ASC'],
          lookupName: searchValue,
        },
      });
    }, 400);

    return () => clearTimeout(handler); // cleanup old timers
  }, [searchValue, lookupTrainingSearch]);

  useEffect(() => {
    if (lookupTrainingSearchData?.lookupTrainingSearch?.nodes)
      setTrainingFilesNodes(
        lookupTrainingSearchData?.lookupTrainingSearch?.nodes
      );
  }, [lookupTrainingSearchData]);

  useEffect(() => {
    if (!searchValue && isModuleHelpEmpty) setIsGlobalSearch(true);
  }, [searchValue]);
  return (
    <Stack
      horizontal
      horizontalAlign="space-between"
      className={styles.searchContainer}
    >
      <Stack horizontal verticalAlign="center" grow={1}>
        <Link
          onClick={() => {
            setIsGlobalSearch(!isGlobalSearch);
            onModeChange();
            setSearchValue(null);
            setTrainingFilesNodes([]);
          }}
          className={styles.textDecoder}
        >
          <Stack tokens={{ padding: '0px 10px 0px 0px' }}>
            <TooltipHost content={'Global'}>
              <Stack
                className={
                  isGlobalSearch
                    ? styles.globalSearchStyle
                    : styles.globalSearchStyleDisable
                }
              >
                <FontIcon
                  iconName={'Globe'}
                  className={
                    isGlobalSearch
                      ? styles.globeStyleIcon
                      : styles.globeStyleIconDisable
                  }
                />
              </Stack>
            </TooltipHost>
          </Stack>
        </Link>
        {!!searchValue?.length && (
          <TooltipHost content={'Clear'}>
            <IconButton
              onClick={() => {
                setSearchValue(null);
              }}
              className={styles.iconBlueStyles}
              iconProps={{ iconName: 'cancel' }}
            />
          </TooltipHost>
        )}
        <Stack grow={1}>
          <SearchBox
            value={searchValue || ''}
            placeholder={searchInputPlaceholderText}
            onChange={(_, value) => {
              setSearchValue(value?.toString()!);
            }}
            autoComplete="off"
            styles={getSearchInputStyles}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};
